<template>
  <DropdownMenuItem
    v-bind="forwardedProps"
    :class="
      cn(
        'tw:relative tw:flex tw:cursor-pointer tw:select-none tw:items-center tw:rounded-sm tw:gap-2 tw:px-2 tw:py-1.5 tw:outline-hidden tw:transition-colors tw:focus:bg-accent tw:focus:text-accent-foreground tw:data-disabled:pointer-events-none tw:data-disabled:opacity-50 tw:[&>svg]:size-4 tw:[&>svg]:shrink-0',
        inset && 'tw:pl-8',
        'tw:[&>label]:w-full',
        props.class,
      )
    "
  >
    <slot />
  </DropdownMenuItem>
</template>

<script setup>
import { DropdownMenuItem, useForwardProps } from 'reka-ui'
import { computed } from 'vue'
import { cn } from '@/shadcn/lib/utils'

const props = defineProps({
  disabled: { type: Boolean, required: false },
  textValue: { type: String, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
  inset: { type: Boolean, required: false },
})

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
</script>
